var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvMicrosoftStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7466_3570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 9H9V16H16V9Z",
    fill: "#FEBA08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9H0V16H7V9Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0H9V7H16V0Z",
    fill: "#80BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0H0V7H7V0Z",
    fill: "#F25325"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7466_3570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvMicrosoftStore);
export default __webpack_public_path__ + "static/media/ctv_microsoft_store.efcbb8aa02c03d52ad1d6762ed1738e8.svg";
export { ForwardRef as ReactComponent };